import { visuallyHidden } from '@insify/css/classes.module.css';
import { TrackedInputCheckbox } from '@objectiv/tracker-react';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import { Minus, Plus } from '../../icons';
import { Loader } from '../Loader';

import * as styles from './ActionButton.module.css';

import type { Testid } from '../../types';
import type { TrackingProps } from '../types';
import type React from 'react';

export type Props = Omit<React.ComponentPropsWithoutRef<'input'>, 'children' | 'type'> &
  Partial<TrackingProps> &
  Testid & {
    Input?: React.ComponentType;
    loading?: boolean;
  };

// https://www.figma.com/file/ssGmau7DMZsdIX7F6k0lGk/%E2%9A%A1%EF%B8%8F-Design-System?type=design&node-id=508-9224&mode=design&t=ofKIuOSPHQWXBcWo-0
export const ActionButton = forwardRef<HTMLInputElement, Props>(
  (
    {
      className,
      Input = TrackedInputCheckbox,
      'data-testid': testId,
      loading = false,
      disabled = false,
      trackingId = 'action-button',
      ...props
    },
    ref,
  ) => {
    const id = props.id ?? uuid();

    return (
      <>
        <Input
          ref={ref}
          className={visuallyHidden}
          objectiv={{ id: trackingId, trackValue: true }}
          {...props}
          id={id}
          disabled={disabled || loading}
        />
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control -- it has linked with id but eslint doesn't recognize TrackedInputCheckbox as an input */}
        <label
          htmlFor={id}
          className={clsx(styles.actionButton, className, { [styles.loading]: loading })}
          data-testid={testId}
        >
          <Plus className={styles.plus} />
          <Minus className={styles.minus} />
          <Loader className={styles.loader} loading={loading} />
        </label>
      </>
    );
  },
);
